export default defineNuxtPlugin(async () => {
  const config = useRuntimeConfig()
  const flags = useFeatureFlags()
  const visitorId = useCookie('carify_visitor_id', { maxAge: 60 * 60 * 24 * 365, sameSite: 'lax' })
  visitorId.value ||= crypto.randomUUID()

  // Runs during SSR; the client reuses the payload. Backend down means all flags off.
  await callOnce('feature-flags', async () => {
    const res = await $fetch(`${config.public.apiUrl}/public_api/settings/feature_flags/`).catch(() => ({}))
    flags.value = resolveFlags(res.results || {}, visitorId.value)
  })
})
